<div class="log-container">
	@if (!isLoadingLogs) {
		@if (!ciLogs || ciLogs.length === 0) {
			<div class="log">
				{{ labels.lbl_cmdb_nenhum_log }}
			</div>
		}

		@for (log of ciLogs; let index = $index; track log) {
			<div class="log">
				<div class="log-date" [title]="'BASELINE'">
					<span class="link" (click)="viewBaseline(log.log_date)">{{ dateService.formatDate(log.log_date) }}</span>
					<span> - {{ log.status }}</span>
				</div>
				<span class="log-date">{{ log.analyst }}</span>
				<span class="log-notes" [innerHTML]="log.notes"></span>
			</div>
		}
	}

	@if (isLoadingLogs) {
		<cpi-dot-bounce-loading-effect [color]="'var(--primary-color-1)'"></cpi-dot-bounce-loading-effect>
	}
</div>
